import { MobizHttpErrorResponse } from '../data/mobiz-http-error-response.do';

import { KnownError } from './known.error';

/**
 * Error to be emitted for when access to a resource has been denied.
 */
export class AccessDeniedError extends KnownError<MobizHttpErrorResponse> {
  public readonly name: string = 'AccessDeniedError';
}
